<template>

    <div class="advanced-connection">

        <header-band :back="true" :logoCleanfox="isDesktop" @eventBack="back"></header-band>

        <div class="container">

            <div class="intro" v-show="!showBloc">

                <div class="tuile">

                    <div class="body">

                        <img src="/img/landing/imap.svg" class="img__96">

                        <p class="title-baseSemibold mt__32">{{ $t('advanced_connection') }}</p>

                        <p class="text-lRegular mt__8">{{ $t('login_imap_tutorial_desc') }}</p>
                    </div>

                    <div class="bottom">

                        <button class="cta-fluid-primary" @click="showBloc = true">{{ $t('global_cta_understood') }}</button>

                    </div>

                </div>
            </div>

            <div class="bloc" v-show="showBloc">

                <h1 class="title-baseSemibold">{{ $t('advanced_connection') }}</h1>

                <input-label class="mt__64"
                             :value="email"
                             :disable="true"
                ></input-label>

                <input-label class="mt__8"
                             :value="password"
                             :placeholder="$t('login_password_placeholder')"
                             :autocomplete="'current-password'"
                             :error="passwordError"
                             @update="val => password = val"
                ></input-label>

                <input-label class="mt__8"
                             :value="server"
                             :placeholder="$t('login_imap_server')"
                             @update="val => server = val"
                ></input-label>

                <input-label class="mt__8"
                             :value="port"
                             :placeholder="$t('login_imap_port')"
                             :type="'number'"
                             @update="val => port = val"
                ></input-label>

                <div class="tls">
                    <span class="text-lMedium">{{ $t('login_imap_tls') }}</span>
                    <checkbox-circle-v2 :value="isTLS" @click="isTLS = !isTLS"></checkbox-circle-v2>
                </div>

                <button class="mt__32 cta-fluid-primary" :disabled="isCtaDisable" @click="loginAdvancedConnection">
                    <lottie-loader :size="24" v-if="isRequesting"></lottie-loader>
                    <span v-else>{{ $t('global_cta_next') }}</span>
                </button>

            </div>

        </div>


    </div>

</template>

<script>
import Login from '../modules/login'
import SessionStorage from '../helpers/sessionStorage'

import CheckboxCircleV2 from '../components/inputs/CheckboxCircleV2.vue'
import HeaderBand from '../components/headers/HeaderBand.vue'
import InputLabel from '../components/inputs/InputLabel.vue'
import LottieLoader from '../components/lottie/LottieLoader.vue'


export default {

    name: 'advanced-connection',

    components: {
        CheckboxCircleV2,
        HeaderBand,
        InputLabel,
        LottieLoader
    },

    computed: {
        isFormNotValid() {
            return !(this.password && this.server && this.port)
        },

        isCtaDisable() {
            return this.isFormNotValid || this.isRequesting
        }
    },


    data() {
        return {
            showBloc: false,
            email: '',
            password: '',
            server: '',
            port: '',
            isTLS: false,
            isRequesting: false,
            passwordError: ''
        }
    },

    mounted() {
        const email = SessionStorage.getItem(SessionStorage.KEYS.EMAIL)
        if (email) {
            this.email = email
        } else {
            this.routerPush('/login/email')
        }

    },

    methods: {

        back() {
            this.routerPush('/login')
        },

        loginAdvancedConnection() {
            if (!this.isFormNotValid && !this.isRequesting) {
                this.isRequesting = true
                this.cleanFormErrors()
                Login.connect({
                    vue: this,
                    email: this.email,
                    password: this.password,
                    server: this.server,
                    port: this.port,
                    secured: this.isTLS
                }).catch(error => {
                    if (error && error.message) {
                        switch (error.message) {
                            case 'invalid_credentials':
                                this.passwordError = this.$t('incorrect_password')
                                break
                        }
                    }
                }).finally(() => {
                    this.isRequesting = false
                })
            }
        },

        cleanFormErrors() {
            this.passwordError = ''
        }

    }
}
</script>

<style lang="scss" scoped>

.advanced-connection {
    display: flex;
    flex-direction: column;
    flex: 1;

    .intro {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100%;
        text-align: start;
        @media screen and (min-width: $above-tablet-length) {
            align-items: center;
            justify-content: center;
        }

        .tuile {
            display: flex;
            flex-direction: column;
            flex: 1;
            height: 100%;

            @media screen and (min-width: $above-tablet-length) {
                max-width: 400px;
                background-color: $white;
                border-radius: 16px;
                flex: initial;
                height: initial;
            }


            .body {
                padding: 32px 16px 16px;
                display: flex;
                flex-direction: column;
                flex: 1;

                @media screen and (min-width: $above-tablet-length) {
                    flex: initial;
                }
            }

            .bottom {
                padding: 20px;
                display: flex;
                align-content: center;
                justify-content: center;
                border-top: 1px solid $platinum;

                @media screen and (min-width: $above-tablet-length) {
                    border: none;
                }
            }
        }
    }

    .container {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        @media screen and (min-width: $above-tablet-length) {
            background-color: $timberwolf;
            align-items: center;
        }

        .bloc {
            display: flex;
            flex-direction: column;
            width: 100%;
            padding: 16px;
            @media screen and (min-width: $above-tablet-length) {
                background-color: $white;
                max-width: 454px;
                padding: 32px;
                border-radius: 16px;
            }

            .tls {
                margin-top: 8px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                padding: 12px 16px;
                border: 1px solid $platinum;
                border-radius: 12px;
            }
        }
    }

}

</style>
